import { render, staticRenderFns } from "./LkFinances.vue?vue&type=template&id=b3c652e0&scoped=true&"
import script from "./LkFinances.vue?vue&type=script&lang=js&"
export * from "./LkFinances.vue?vue&type=script&lang=js&"
import style0 from "./LkFinances.vue?vue&type=style&index=0&id=b3c652e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c652e0",
  null
  
)

export default component.exports